var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChatPlugin_instances, _a, _ChatPlugin_pubSub, _ChatPlugin_state, _ChatPlugin_grantResult, _ChatPlugin_apolloClient, _ChatPlugin_s10ChannelId, _ChatPlugin_chatPluginSubscription, _ChatPlugin_grantResultSubscription, _ChatPlugin_chatPluginFields, _ChatPlugin_banQueue, _ChatPlugin_onGrantResultUpdate, _ChatPlugin_publishGrantResult, _ChatPlugin_publishPluginState, _ChatPlugin_optimisticChatBan;
import globalLogger from "@lazarentertainment/js-logger";
import { BanUserFromPublicChatDocument, ChatPreferencesDocument, DisablePluginsDocument, EnablePluginsDocument, GetChatBansDocument, GetPublicChatAccessDocument, GrantResultUpdatedDocument, OnPluginEventDocument, PluginState, PluginsDocument, RegenerateChatApiKeyDocument, UnbanUserFromPublicChatDocument, ValidateDisplayNameDocument, } from "./plugin-service/build";
import { KeyedOperationsQueue, getErrors } from "./util/keyedOperationsQueue";
import { createStatefulPubSub, } from "./util/statefulPubSub";
export class ChatPlugin {
    constructor({ apolloClient, pubSub, s10ChannelId, onGrantResultUpdate, }) {
        _ChatPlugin_instances.add(this);
        _ChatPlugin_pubSub.set(this, void 0);
        _ChatPlugin_state.set(this, void 0);
        _ChatPlugin_grantResult.set(this, void 0);
        _ChatPlugin_apolloClient.set(this, void 0);
        _ChatPlugin_s10ChannelId.set(this, void 0);
        _ChatPlugin_chatPluginSubscription.set(this, void 0);
        _ChatPlugin_grantResultSubscription.set(this, void 0);
        // Tracking this value just helps us populate optimisticResponse
        _ChatPlugin_chatPluginFields.set(this, void 0);
        _ChatPlugin_banQueue.set(this, new KeyedOperationsQueue());
        _ChatPlugin_onGrantResultUpdate.set(this, void 0);
        this.getApiKey = () => __classPrivateFieldGet(this, _ChatPlugin_state, "f").get("apiKey");
        this.getBans = () => __classPrivateFieldGet(this, _ChatPlugin_state, "f").get("bans");
        this.getPluginState = () => __classPrivateFieldGet(this, _ChatPlugin_state, "f").get("pluginState");
        this.loadApiKey = () => __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _ChatPlugin_state, "f").set("apiKey", yield this.fetchApiKey());
        });
        this.toggleChatEnabledState = (enabled) => __awaiter(this, void 0, void 0, function* () {
            if (enabled) {
                yield this.enableChat();
            }
            else {
                yield this.disableChat();
            }
        });
        this.banUser = ({ displayName, sourceName, userId, }) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            const channelId = __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f");
            const [banPromise] = __classPrivateFieldGet(this, _ChatPlugin_banQueue, "f").enqueue(userId, () => __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").mutate({
                mutation: BanUserFromPublicChatDocument,
                variables: {
                    channelId,
                    displayName,
                    sourceName,
                    userId,
                },
                update: (cache, { data }) => {
                    const newChatBan = data === null || data === void 0 ? void 0 : data.chat_banUserFromPublicChat;
                    if (newChatBan) {
                        cache.updateQuery({
                            query: GetChatBansDocument,
                            variables: { channelId },
                        }, (prevQuery) => {
                            const chatBans = [
                                ...((prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.chat_chatBans) || []).filter((chatBan) => chatBan.userId !== newChatBan.userId),
                                newChatBan,
                            ];
                            __classPrivateFieldGet(this, _ChatPlugin_state, "f").set("bans", chatBans);
                            return Object.assign(Object.assign({}, prevQuery), { 
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                chat_chatBans: chatBans });
                        });
                    }
                },
                optimisticResponse: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    chat_banUserFromPublicChat: __classPrivateFieldGet(_a, _a, "m", _ChatPlugin_optimisticChatBan).call(_a, {
                        displayName,
                        sourceName,
                        userId,
                    }),
                },
            }));
            const { type, value } = yield banPromise;
            if (type === "completed") {
                const ban = (_b = value.data) === null || _b === void 0 ? void 0 : _b.chat_banUserFromPublicChat;
                if (ban) {
                    __classPrivateFieldGet(this, _ChatPlugin_pubSub, "f").publish("ban", ban);
                }
            }
        });
        this.unbanUser = ({ userId, sourceName, }) => __awaiter(this, void 0, void 0, function* () {
            var _c;
            const channelId = __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f");
            const key = `${userId}:${sourceName}`;
            const [unbanPromise] = __classPrivateFieldGet(this, _ChatPlugin_banQueue, "f").enqueue(key, () => __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").mutate({
                mutation: UnbanUserFromPublicChatDocument,
                variables: {
                    channelId,
                    userId,
                    sourceName,
                },
                update: (cache, { data }) => {
                    const deletedChatBan = data === null || data === void 0 ? void 0 : data.chat_unbanUserFromPublicChat;
                    if (deletedChatBan) {
                        cache.updateQuery({
                            query: GetChatBansDocument,
                            variables: { channelId },
                        }, (prevQuery) => {
                            var _b;
                            const chatBans = ((_b = prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.chat_chatBans) !== null && _b !== void 0 ? _b : []).filter((ban) => ban.userId !== deletedChatBan.userId);
                            __classPrivateFieldGet(this, _ChatPlugin_state, "f").set("bans", chatBans);
                            return Object.assign(Object.assign({}, prevQuery), { 
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                chat_chatBans: chatBans });
                        });
                    }
                },
                optimisticResponse: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    chat_unbanUserFromPublicChat: __classPrivateFieldGet(_a, _a, "m", _ChatPlugin_optimisticChatBan).call(_a, {
                        userId,
                        sourceName,
                    }),
                },
            }));
            const { type, value } = yield unbanPromise;
            if (type === "completed") {
                const unban = (_c = value.data) === null || _c === void 0 ? void 0 : _c.chat_unbanUserFromPublicChat;
                if (unban) {
                    __classPrivateFieldGet(this, _ChatPlugin_pubSub, "f").publish("unban", unban);
                }
            }
        });
        this.regenerateApiKey = () => __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f")
                .mutate({
                mutation: RegenerateChatApiKeyDocument,
            })
                .then(({ data }) => {
                if (data) {
                    __classPrivateFieldGet(this, _ChatPlugin_state, "f").set("apiKey", data.chat_regenerateApiKey.publicChat.apiKey);
                }
            });
        });
        this.loadBans = () => __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _ChatPlugin_state, "f").set("bans", yield this.fetchBans());
        });
        this.unbanAllUsers = () => this.unbanUsers(this.getBans().map((ban) => ({
            userId: ban.userId,
            sourceName: ban.sourceName,
        })));
        __classPrivateFieldSet(this, _ChatPlugin_s10ChannelId, s10ChannelId, "f");
        __classPrivateFieldSet(this, _ChatPlugin_apolloClient, apolloClient, "f");
        __classPrivateFieldSet(this, _ChatPlugin_pubSub, pubSub, "f");
        __classPrivateFieldSet(this, _ChatPlugin_onGrantResultUpdate, onGrantResultUpdate, "f");
        __classPrivateFieldSet(this, _ChatPlugin_state, createStatefulPubSub({
            pluginState: "initializing",
            bans: [],
            apiKey: null,
        }, __classPrivateFieldGet(this, _ChatPlugin_pubSub, "f")), "f");
        // TODO: error handling
        __classPrivateFieldGet(this, _ChatPlugin_banQueue, "f").subscribe("errors", (errors) => globalLogger.error(...getErrors(errors)));
        __classPrivateFieldSet(this, _ChatPlugin_chatPluginSubscription, __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f")
            .subscribe({
            query: OnPluginEventDocument,
            variables: {
                channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
            },
        })
            .subscribe(({ data }) => {
            var _b;
            const plugin = (_b = data === null || data === void 0 ? void 0 : data.pluginEvent) === null || _b === void 0 ? void 0 : _b.plugin;
            if (plugin && isChatPlugin(plugin)) {
                __classPrivateFieldGet(this, _ChatPlugin_instances, "m", _ChatPlugin_publishPluginState).call(this, plugin);
            }
        }, globalLogger.error), "f");
    }
    get grantResult() {
        return __classPrivateFieldGet(this, _ChatPlugin_grantResult, "f");
    }
    loadPluginState() {
        var _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: pluginData } = yield __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").query({
                query: PluginsDocument,
                variables: {
                    channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                    cursor: null,
                },
            });
            __classPrivateFieldGet(this, _ChatPlugin_instances, "m", _ChatPlugin_publishPluginState).call(this, (_c = (_b = pluginData === null || pluginData === void 0 ? void 0 : pluginData.plugins) === null || _b === void 0 ? void 0 : _b.plugins) === null || _c === void 0 ? void 0 : _c.find(isChatPlugin));
        });
    }
    fetchApiKey() {
        var _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: chatData } = yield __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").query({
                query: ChatPreferencesDocument,
            });
            return (_c = (_b = chatData === null || chatData === void 0 ? void 0 : chatData.instance) === null || _b === void 0 ? void 0 : _b.publicChat.apiKey) !== null && _c !== void 0 ? _c : null;
        });
    }
    loadGrantResult() {
        var _b;
        return __awaiter(this, void 0, void 0, function* () {
            const currentUserId = (_b = __classPrivateFieldGet(this, _ChatPlugin_grantResult, "f")) === null || _b === void 0 ? void 0 : _b.userId;
            const { data: { chat_publicChatAccess: grantResult }, } = yield __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").query({
                query: GetPublicChatAccessDocument,
                fetchPolicy: "network-only",
            });
            __classPrivateFieldGet(this, _ChatPlugin_instances, "m", _ChatPlugin_publishGrantResult).call(this, grantResult);
            const { userId } = grantResult;
            if (__classPrivateFieldGet(this, _ChatPlugin_grantResultSubscription, "f")) {
                if (currentUserId === userId) {
                    return grantResult;
                }
                __classPrivateFieldGet(this, _ChatPlugin_grantResultSubscription, "f").unsubscribe();
            }
            __classPrivateFieldSet(this, _ChatPlugin_grantResultSubscription, __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f")
                .subscribe({
                query: GrantResultUpdatedDocument,
                variables: {
                    channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                    userId,
                },
            })
                .subscribe(({ data }) => {
                __classPrivateFieldGet(this, _ChatPlugin_instances, "m", _ChatPlugin_publishGrantResult).call(this, data === null || data === void 0 ? void 0 : data.chat_grantResultUpdated);
            }, globalLogger.error), "f");
            return grantResult;
        });
    }
    /**
     * Validates the name against the plugin-service to determine if it is allowed
     * (i.e. not profane etc.).
     *
     * If the request itself succeeds then this will return a boolean indicating
     * whether the name is valid or not.
     *
     * If the request itself fails then the returned Promise will be rejected.
     *
     * Therefore it's important to distinguish between and handle these two cases.
     * A successful call with an invalid name looks different than a network error,
     * for example.
     */
    validateDisplayName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { chat_validateDisplayName: isValid }, } = yield __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").query({
                query: ValidateDisplayNameDocument,
                variables: { displayName: name },
            });
            return isValid;
        });
    }
    enableChat() {
        return __awaiter(this, void 0, void 0, function* () {
            const pluginFields = __classPrivateFieldGet(this, _ChatPlugin_chatPluginFields, "f")
                ? Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ChatPlugin_chatPluginFields, "f")), { state: PluginState.Enabled }) : null;
            yield __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").mutate({
                mutation: EnablePluginsDocument,
                variables: {
                    command: {
                        channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                        broadcastId: null,
                        plugins: [
                            {
                                pluginKey: "chat",
                                options: {
                                    overridePersistence: true,
                                },
                                persistent: true,
                            },
                        ],
                    },
                },
                update: (cache, { data }) => {
                    __classPrivateFieldGet(this, _ChatPlugin_instances, "m", _ChatPlugin_publishPluginState).call(this, data === null || data === void 0 ? void 0 : data.enablePlugins.find(isChatPlugin));
                    cache.updateQuery({
                        query: PluginsDocument,
                        variables: {
                            channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                            cursor: null,
                        },
                    }, (prevQuery) => {
                        var _b;
                        return Object.assign(Object.assign({}, prevQuery), { plugins: Object.assign(Object.assign({}, prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.plugins), { plugins: (_b = data === null || data === void 0 ? void 0 : data.enablePlugins) !== null && _b !== void 0 ? _b : [] }) });
                    });
                },
                optimisticResponse: {
                    enablePlugins: pluginFields ? [pluginFields] : [],
                },
            });
        });
    }
    disableChat() {
        return __awaiter(this, void 0, void 0, function* () {
            const pluginFields = __classPrivateFieldGet(this, _ChatPlugin_chatPluginFields, "f")
                ? Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ChatPlugin_chatPluginFields, "f")), { state: PluginState.Disabled }) : null;
            yield __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f").mutate({
                mutation: DisablePluginsDocument,
                variables: {
                    command: {
                        channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                        plugins: [
                            {
                                pluginKey: "chat",
                                options: {
                                    overridePersistence: true,
                                },
                                persistent: true,
                            },
                        ],
                    },
                },
                update: (cache, { data }) => {
                    __classPrivateFieldGet(this, _ChatPlugin_instances, "m", _ChatPlugin_publishPluginState).call(this, data === null || data === void 0 ? void 0 : data.disablePlugins.find(isChatPlugin));
                    cache.updateQuery({
                        query: PluginsDocument,
                        variables: {
                            channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                            cursor: null,
                        },
                    }, (prevQuery) => {
                        var _b;
                        return Object.assign(Object.assign({}, prevQuery), { plugins: Object.assign(Object.assign({}, prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.plugins), { plugins: (_b = data === null || data === void 0 ? void 0 : data.disablePlugins) !== null && _b !== void 0 ? _b : [] }) });
                    });
                },
                optimisticResponse: {
                    disablePlugins: pluginFields ? [pluginFields] : [],
                },
            });
        });
    }
    unbanUsers(users) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.allSettled(users.map((user) => this.unbanUser(user)));
        });
    }
    fetchBans() {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _ChatPlugin_apolloClient, "f")
                .query({
                query: GetChatBansDocument,
                variables: {
                    channelId: __classPrivateFieldGet(this, _ChatPlugin_s10ChannelId, "f"),
                },
            })
                .then(({ data }) => data.chat_chatBans);
        });
    }
    close() {
        var _b, _c;
        (_b = __classPrivateFieldGet(this, _ChatPlugin_chatPluginSubscription, "f")) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = __classPrivateFieldGet(this, _ChatPlugin_grantResultSubscription, "f")) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        __classPrivateFieldGet(this, _ChatPlugin_banQueue, "f").abortAll();
    }
}
_a = ChatPlugin, _ChatPlugin_pubSub = new WeakMap(), _ChatPlugin_state = new WeakMap(), _ChatPlugin_grantResult = new WeakMap(), _ChatPlugin_apolloClient = new WeakMap(), _ChatPlugin_s10ChannelId = new WeakMap(), _ChatPlugin_chatPluginSubscription = new WeakMap(), _ChatPlugin_grantResultSubscription = new WeakMap(), _ChatPlugin_chatPluginFields = new WeakMap(), _ChatPlugin_banQueue = new WeakMap(), _ChatPlugin_onGrantResultUpdate = new WeakMap(), _ChatPlugin_instances = new WeakSet(), _ChatPlugin_publishGrantResult = function _ChatPlugin_publishGrantResult(grantResult) {
    if (grantResult) {
        __classPrivateFieldSet(this, _ChatPlugin_grantResult, grantResult, "f");
        __classPrivateFieldGet(this, _ChatPlugin_onGrantResultUpdate, "f").call(this, grantResult);
    }
}, _ChatPlugin_publishPluginState = function _ChatPlugin_publishPluginState(pluginFields) {
    __classPrivateFieldSet(this, _ChatPlugin_chatPluginFields, pluginFields, "f");
    if (pluginFields) {
        __classPrivateFieldGet(this, _ChatPlugin_state, "f").set("pluginState", pluginFields.state);
    }
}, _ChatPlugin_optimisticChatBan = function _ChatPlugin_optimisticChatBan({ userId, sourceName, displayName, }) {
    return {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __typename: "Chat_ChatBan",
        userId,
        sourceName,
        displayName: displayName !== null && displayName !== void 0 ? displayName : "",
        createdAt: new Date().toISOString(),
        expiresAt: null,
        id: "",
    };
};
function isChatPlugin(data) {
    var _b;
    return ((_b = data === null || data === void 0 ? void 0 : data.pluginDefinition) === null || _b === void 0 ? void 0 : _b.key) === "chat";
}
